import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FaStar, FaShoppingCart, FaHeart, FaUser, FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';
import { useCart } from '../context/CartContext';
import { useState, useEffect, useRef } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navRef = useRef(null);
  const buttonRef = useRef(null);


  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


  const closeMenu = () => {
    setIsMenuOpen(false);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        navRef.current &&
        buttonRef.current &&
        !navRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        closeMenu();
      }
    };


    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        closeMenu();
      }
    };


    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }


    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const { getCartCount } = useCart();
  const cartCount = getCartCount();

  return (
    <header className="header">
      <div className="container header-inner">
        <Link to="/" className="logo">
          <img src="/images/logo.jpg" alt="Novurem Logo" width="50" height="50" />
          <div>
            <div className="logo-text">Novurem</div>
            <div className="logo-sub">Patisserie</div>
          </div>
        </Link>
                <button 
          ref={buttonRef}
          className="hamburger-menu" 
          onClick={toggleMenu}
          aria-label="Toggle menu">
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

<nav ref={navRef} className={isMenuOpen ? 'active' : ''}>
          <ul className="nav-menu">
            <li className="nav-item">
              <NavLink to="/" className="nav-link" end ref={navRef} className={isMenuOpen ? 'active' : ''}>
                <FaHome /> Startseite
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/about" className="nav-link" ref={navRef} className={isMenuOpen ? 'active' : ''}>
                <FaHeart /> Über uns
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contact" className="nav-link" ref={navRef} className={isMenuOpen ? 'active' : ''}>
                <FaPhone /> Kontakt
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/cart" className="nav-link" ref={navRef} className={isMenuOpen ? 'active' : ''}>
                <FaShoppingCart /> Warenkorb {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
              </NavLink>
            </li>
          </ul>
        </nav>
        <div className="header-actions">
          <Link to="/about" className="btn btn-primary btn-sm">
            <FaUser /> Mein Konto
          </Link>
        </div>
      </div>
    </header>
  );
}